
export enum CalendarRoomDisplayType {
	ROOM_MAPPING='ROOM_MAPPING', ROOM_NAME='ROOM_NAME'
}